import React, { useEffect } from 'react';

import { QuestionCircleOutlined, CloseOutlined } from '@ant-design/icons';

import { useHelpModeContext } from './HelpModeContext';

const HelpModeOverlay: React.FC = () => {
  const { isHelpMode, disableHelpMode } = useHelpModeContext();

  useEffect(() => {
    if (isHelpMode) {
      document.body.classList.add('help-mode-active');
    } else {
      document.body.classList.remove('help-mode-active');
    }

    return () => {
      document.body.classList.remove('help-mode-active');
    };
  }, [isHelpMode]);

  if (!isHelpMode) return null;

  return (
    <div
      style={{
        position: 'fixed',
        bottom: 20,
        right: 20,
        background: '#1890ff',
        color: '#fff',
        padding: '10px 16px',
        borderRadius: 8,
        fontSize: 13,
        zIndex: 1200,
        display: 'flex',
        alignItems: 'center',
        gap: 10,
        boxShadow: '0 2px 12px rgba(0, 0, 0, 0.2)',
        cursor: 'pointer',
        userSelect: 'none',
      }}
      onClick={(e) => {
        e.stopPropagation();
        disableHelpMode();
      }}
    >
      <QuestionCircleOutlined style={{ fontSize: 16 }} />
      <span>Режим помощи активен</span>
      <span style={{ opacity: 0.7, fontSize: 11, marginLeft: 4 }}>
        Shift+клик — обычное действие | Shift+H / Esc — выход
      </span>
      <CloseOutlined style={{ fontSize: 12, opacity: 0.8, marginLeft: 4 }} />
    </div>
  );
};

export default HelpModeOverlay;
